import { render, staticRenderFns } from "./StateChemistryDistricts.vue?vue&type=template&id=9447fd74&scoped=true&"
import script from "./StateChemistryDistricts.vue?vue&type=script&lang=js&"
export * from "./StateChemistryDistricts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9447fd74",
  null
  
)

export default component.exports